// extracted by mini-css-extract-plugin
export default {"containerDefault":"Icon_containerDefault__fx7A0"};